import React, { useEffect, useRef, useState } from "react";
import AllImages from "../../constant/img";
import PORTNUMBER from "../../constant/api";
import { useLocation, Link } from "react-router-dom";
import Commmon from "../menu/common";
import Logo from "../menu/logo";
import Monetization from "../menu/monetization";
import Cms from "../menu/cms";
import UserAccount from "../menu/userAccount";
import Categories from "../menu/categories";
import Product from "../menu/product";
import Faq from "../menu/faq";
import Brand from "../menu/brand";
import Slider from "../menu/slider";
import NewsletterManagement from "../menu/newslettermanagement";
import ContactUs from "../menu/contact";
import DeactivateAccountReason from "../menu/deactivateaccountreason";
import Learn from "../menu/learn";
import { getCurrentMenuHref } from "./sidebarCurrent";

const Sidebar = () => {
  const menuRef = useRef(null);
  const [menuSearch, setMenuSearch] = useState("");
  const [menuMatches, setMenuMatches] = useState([]);
  const searchMenu = (event) => {
    const value = event.target.value;
    setMenuSearch(value);
    const query = value.trim().toLowerCase();
    const links = Array.from(menuRef.current?.querySelectorAll('a[href]') || []);
    const seen = new Set();
    setMenuMatches(query ? links.filter(link => {
      const href = link.getAttribute('href');
      if (link.getAttribute('data-toggle') === 'collapse' || !href.startsWith('/') || href === '/' || seen.has(href)) return false;
      // Match the page name or the section it sits in ("CMS" lists Pages and Blocks).
      const groupLabel = link.closest('.sidebar-dropdown')?.querySelector(':scope > a')?.textContent.trim().toLowerCase() || '';
      if (!link.textContent.toLowerCase().includes(query) && !groupLabel.includes(query)) return false;
      seen.add(href);
      return true;
    }).map(link => {
      const group = link.closest('.sidebar-dropdown')?.querySelector(':scope > a')?.textContent.trim();
      const name = link.textContent.trim();
      return {href:link.getAttribute('href'), label: group && group !== name ? `${group} › ${name}` : name};
    }) : []);
  };

  const PORT = PORTNUMBER.PORTNUMBER;
  const location = useLocation();
  const pathname = location.pathname;
  // console.log("pathnamehaiyesidebarme", location.pathname);

  // Marks the current page's link, highlights its section and opens it. Re-applied a few times after the route change:
  // the menu is rebuilt/restyled by other scripts right after the first render, which left nothing highlighted
  // when a page was opened directly (e.g. /Blocks) or after a refresh.
  useEffect(() => {
    setMenuSearch("");
    setMenuMatches([]);
    const applyCurrent = () => {
      const root = menuRef.current;
      if (!root) return;
      // Section headers (<Link to="#" data-toggle="collapse">) resolve to the CURRENT path as their href, so they
      // looked like the current page's link and took the highlight. Only real page links count.
      const links = Array.from(root.querySelectorAll('a[href^="/"]')).filter(link => link.getAttribute('data-toggle') !== 'collapse');
      const hrefs = links.map(link => link.getAttribute('href'));
      const currentHref = getCurrentMenuHref(pathname, hrefs);
      const current = links.find(link => link.getAttribute('href') === currentHref);
      links.forEach(link => { link.classList.toggle('admin-menu-current', link === current); if (link === current) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current'); });
      root.querySelectorAll('.admin-menu-section-active').forEach(group => group.classList.remove('admin-menu-section-active'));
      const currentGroup = current?.closest('.sidebar-dropdown');
      // Only the section of the page on screen stays open (the other sections would still look "selected").
      root.querySelectorAll('.sidebar-dropdown').forEach(group => {
        if (group !== currentGroup) group.querySelector('.collapse.show')?.classList.remove('show');
      });
      if (current) {
        currentGroup?.classList.add('admin-menu-section-active');
        const submenu = currentGroup?.querySelector('.collapse');
        submenu?.classList.add('show');
        if (submenu) submenu.style.display = '';
      }
    };
    applyCurrent();
    const timers = [150, 600, 1500].map(delay => setTimeout(applyCurrent, delay));
    return () => timers.forEach(clearTimeout);
  }, [pathname]);
  const allPathEdit = pathname.split("/");
  // console.log("allpathinsidebar", allPathEdit);

  const handleRemove = () => {
    document.body.classList.remove("overflow-none");
  };
  const siderRemove = () => {
    document.body.classList.remove("hidemenu_title");
  };

  if (
    location.pathname == "/" ||
    location.pathname == "/forgetPassword" ||
    allPathEdit[1] == "confirmPassword"
  ) {
    return null;
  } else {
    return (
      <div
        class="left_menubar chiller-theme toggled mCustomScrollbar"
        data-mcs-theme="dark"
      >
        <div onClick={handleRemove} class="transparent-layer"></div>
        <nav onMouseEnter={siderRemove} id="sidebar" class="sidebar-wrapper">
          <div onClick={handleRemove} id="filter-closer">
            <img src={AllImages.CANCEL_IMAGE} alt="icon" />
          </div>
          <div class="logo_header">
            <Link to="/admin">
              <img
                class="logoslice01"
                src="/images/drotly-logo-dark.png"
                alt="Drotly"
              />
            </Link>
          </div>

          {<div className="png-admin-menu-search"><input type="search" aria-label="Search admin navigation" placeholder="Search" value={menuSearch} onChange={searchMenu} /></div>}
          {menuSearch.trim() && <div className="png-admin-menu-matches">{menuMatches.length ? menuMatches.map(item => <Link key={item.href} to={item.href}>{item.label}</Link>) : <p>No matching pages</p>}</div>}
          <div class="sidebar-content" hidden={Boolean(menuSearch.trim())}>
            <div className="sidebar-menu" id="accordion" ref={menuRef}>
              <ul>
                <Commmon props={pathname} />
                <Logo props={pathname} />
                <Monetization props={pathname} />
                <Categories props={pathname} />
                <UserAccount props={pathname} />
                <Cms props={pathname} />
                <Product props={pathname} />
                <Brand props={pathname} />
                <Slider props={pathname} />
                <Faq props={pathname} />
                <Learn props={pathname} />
                <ContactUs props={pathname} />
                <NewsletterManagement props={pathname} />
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
};

export default Sidebar;
